import { useEffect, useState } from 'react';
import { KeyRound, LogOut, MapPin, Phone, UserRound } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import Alert from '../components/common/Alert';
import BrandMark from '../components/common/BrandMark';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { useAuth } from '../context/AuthContext';
import { voterService } from '../services';

function VoterPortalPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    voterService.getMyProfile()
      .then((response) => mounted && setProfile(response.data))
      .catch((requestError) => mounted && setError(requestError.message));
    return () => { mounted = false; };
  }, []);

  const signOut = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-surface-page">
      <header className="border-b border-white/10 bg-slate-950">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-5 py-4">
          <BrandMark />
          <Button variant="ghost" className="text-slate-200 hover:bg-white/10 hover:text-white" onClick={signOut}>
            <LogOut className="size-4" /> Cerrar sesión
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 py-8">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-semibold text-primary-700">Portal del votante</p>
            <h1 className="mt-1 text-2xl font-semibold text-content-primary">
              Hola, {user.first_name || user.name}
            </h1>
            <p className="mt-1 text-sm text-content-muted">
              Consulta únicamente tu información personal autorizada.
            </p>
          </div>
          <Link
            to="/cambiar-contrasena"
            className="inline-flex h-10 items-center justify-center gap-2 rounded-control bg-secondary-600 px-4 text-sm font-semibold text-white transition hover:bg-secondary-700"
          >
            <KeyRound className="size-4" /> Cambiar contraseña
          </Link>
        </div>

        {error && <Alert variant="danger" title="No se pudo cargar tu perfil" className="mt-6">{error}</Alert>}
        {!profile && !error ? (
          <Card className="mt-6"><div className="grid min-h-48 place-items-center"><LoadingSpinner label="Cargando perfil" /></div></Card>
        ) : profile && (
          <div className="mt-6 grid gap-5">
            <Card title="Información personal" description="Datos asociados a tu cuenta">
              <dl className="space-y-4 text-sm">
                <div className="flex gap-3"><UserRound className="mt-0.5 size-4 text-content-muted" /><div><dt className="text-content-muted">Nombre completo</dt><dd className="font-medium text-content-primary">{profile.nombres} {profile.apellidos}</dd></div></div>
                <div><dt className="text-content-muted">Cédula</dt><dd className="font-medium text-content-primary">{profile.cedula}</dd></div>
                <div className="flex gap-3"><Phone className="mt-0.5 size-4 text-content-muted" /><div><dt className="text-content-muted">Teléfono</dt><dd className="font-medium text-content-primary">{profile.telefono || 'No registrado'}</dd></div></div>
                <div className="flex gap-3"><MapPin className="mt-0.5 size-4 text-content-muted" /><div><dt className="text-content-muted">Dirección</dt><dd className="font-medium text-content-primary">{profile.address || 'No registrada'}</dd></div></div>
                <div><dt className="text-content-muted">Puntero responsable</dt><dd className="font-medium text-content-primary">{profile.puntero_nombre}</dd></div>
              </dl>
            </Card>
          </div>
        )}
      </main>
    </div>
  );
}

export default VoterPortalPage;
